/**
 * Custom element to manage discount input positioning
 * Waits for external app to load stack-discounts-container and moves it to cart-discount-component
 */
class CartDiscountManager extends HTMLElement {
  constructor() {
    super();
    /** @type {MutationObserver | null} */
    this.observer = null;
    /** @type {number | null} */
    this.timeout = null;
  }

  /**
   * Exibe o orquestrador: esconde o fallback, revela o conteúdo e mostra o form
   */
  showOrchestrator() {
    const fallback = document.getElementById('fallback-discounts-container');
    if (fallback) fallback.hidden = true;

    const detailsContent = document.querySelector(
      'cart-discount-component .details-content'
    );
    if (detailsContent instanceof HTMLElement) detailsContent.hidden = false;

    const orchestrator = document.getElementById('cart-discount-orchestrator');
    if (orchestrator) orchestrator.classList.add('show');
  }

  connectedCallback() {
    this.startMonitoring();
  }

  disconnectedCallback() {
    this.stopMonitoring();
  }

  startMonitoring() {
    // Initially hide the container with CSS
    this.hideDiscountContainer();

    // Start observing DOM changes
    this.observeDOMChanges();

    // Set timeout: após 5s, se não carregou DY, mostramos o orquestrador
    this.timeout = setTimeout(() => {
      const container = document.getElementById('stack-discounts-container');
      if (!container) {
        this.showOrchestrator();
      }
    }, 5000);
  }

  stopMonitoring() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  hideDiscountContainer() {
    // CSS is now handled in cart-summary.liquid
    // This method is kept for potential future logic
  }

  observeDOMChanges() {
    // Create a MutationObserver to watch for DOM changes
    this.observer = new MutationObserver(() => {
      // Check if the discount container has been added to the DOM
      const container = document.getElementById('stack-discounts-container');

      if (container) {
        this.moveDiscountContainer(container);
        this.showOrchestrator();
        // Stop observing and clear timeout once handled
        if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
        this.stopMonitoring();
      }
    });

    // Start observing the entire document for changes
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    });

    // Also check immediately in case the element is already there
    const container = document.getElementById('stack-discounts-container');
    if (container) {
      this.moveDiscountContainer(container);
      this.showOrchestrator();
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.stopMonitoring();
    }
  }

  /**
   * @param {HTMLElement} container
   */
  moveDiscountContainer(container) {
    // Find the cart-discount-component and its details-content
    const cartDiscountComponent = document.querySelector(
      'cart-discount-component'
    );

    if (!cartDiscountComponent) {
      return;
    }

    const detailsContent =
      cartDiscountComponent.querySelector('.details-content');

    if (!detailsContent) {
      return;
    }

    // Move the container first
    detailsContent.appendChild(container);

    // Then show the container by adding the active class
    container.classList.add('is-active');

    // Also add active class to cart-discount to show it
    const cartDiscount = cartDiscountComponent.querySelector('.cart-discount');
    if (cartDiscount) {
      cartDiscount.classList.add('active');
    }

    // Dispatch a custom event to notify other components
    this.dispatchEvent(
      new CustomEvent('discount-container-moved', {
        detail: { container, target: detailsContent },
      })
    );

    // Garante que o orquestrador esteja visível quando DY estiver presente
    this.showOrchestrator();
  }
}

// Register the custom element
if (!customElements.get('cart-discount-manager')) {
  customElements.define('cart-discount-manager', CartDiscountManager);
}